<template>
  <v-sheet class="page splash" color="#F5F5F5">
    <v-row class="align-space-between background">
      <!-- <v-spacer></v-spacer> -->

      <v-col cols="12" sm="6" md="6" class="pb-10 pt-10">
        <div
          class="d-flex flex-column align-center text-center fill-height"
          v-if="!isLoggedIn"
        >
          <h1 class="text-lg-h1 mb-10">
            Introduce Yourself
            <br />Before You Interview
          </h1>

          <h4 class="text-h4 mb-15">
            Get Future-Ready & Create
            <br />Your 60-Second Video
          </h4>
          <AuthModal
            buttonText="Start Now"
            mobileButtonText="Start Now"
            color="#FC4A46"
            dark
          />
        </div>

        <div v-else class="d-flex flex-column fill-height justify-center">
          <div>
            <h2 class="text-h2 text-hrng font-weight-bold">
              Welcome {{ firstName }}!
            </h2>
            <h5 class="text-h5 mb-15 font-weight-bold">
              Get Future-Ready
              <br />Create Your 60-Second Video
            </h5>
          </div>

          <div>
            <h5 class="text-h6 font-weight-bold">Let's collaborate!</h5>

            <div class="subtitle-1">
              Our HR experts are ready to help you ace your next interview.
            </div>
            <div class="subtitle-1">
              Check out the job description and tips below.
            </div>
          </div>
        </div>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="3"
        class="pb-0 mb-0 order-md-first d-flex align-end"
        v-if="!isLoggedIn"
      >
        <div class="frame-video-wrapper">
          <div class="frame-secondary-wrapper"></div>
          <div class="frame-tertiary-wrapper"></div>
          <Video :videoId="465124690" width="212" height="380" />
          <!-- <vueVimeoPlayer
            video-id="https://vimeo.com/465124690"
            ref="player"
            autoplay="true"
            player-width="212"
            player-height="380"
            loop="true"
          ></vueVimeoPlayer> -->
        </div>
      </v-col>

      <v-col sm="3" class="pb-0 pr-0 d-none d-md-block" v-if="!isLoggedIn">
        <div
          class="d-flex flex-column justify-end align-center text-center fill-height"
        >
          <v-img
            class="splash-image mt-2"
            src="https://hrng-assets.s3.amazonaws.com/girlflippedlandingpage_b0a1b6060a.png"
          />
        </div>
      </v-col>
      <v-col v-else>
        <div class="subtitle-1 font-weight-bold mb-1">
          <span v-if="video">Your latest video submission:</span>
          <span v-else>Our Team excited to see your first video...</span>
        </div>

        <Video
          :videoId="this.candidateVideo ? this.candidateVideo : '465502166'"
          :key="this.candidateVideo"
          styled="true"
          muted="false"
        />

        <!-- {{ this.$store.user.user.user.candidate.video }} -->

        <!-- <vueVimeoPlayer
          class="vimeo-player"
          :video-id="video ? candidateVideo : 'https://vimeo.com/465502166'"
          ref="player"
          autoplay="true"
          player-width="281.25"
          player-height="500"
          loop="true"
        ></vueVimeoPlayer> -->
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import Video from '@/components/Video';
import AuthModal from '@/components/Auth/AuthModal';
import { authComputed } from '@/store/helpers';

export default {
  data() {
    return {
      candidateVideo: this.video,
    };
  },
  created() {
    if (this.loggedInType === 'recruiter') {
      if (window.location.pathname === '/') {
        this.$router.push('/recruiter/job-posts');
      }
    }
  },
  components: { AuthModal, Video },
  props: ['isLoggedIn', 'firstName', 'video'],
  computed: {
    ...authComputed,
    loggedInType() {
      return this.getUserData.type;
    },
  },
};
</script>

<style lang="scss">
.splash {
  .background {
    background: #f5f5f5;
  }
  /* background: url('https://hrng-assets.s3.amazonaws.com/girlflippedlandingpage_b0a1b6060a.png');
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 30%; */

  .frame-video-wrapper {
    background: #fff;
    /* border: 1px solid #ccc; */
    display: flex;
    justify-content: center;
    align-items: flex-end;
    height: 400px;
    width: 230px;
    position: relative;
    z-index: 99;
    margin: auto;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.18) -20px 20px 80px;

    @media only screen and (min-width: 960px) {
      margin: inherit;
    }
    .frame-secondary-wrapper {
      background: #fff;
      /* border: 1px solid #ccc;
      border-left: none; */
      position: absolute;
      left: 230px;
      height: 360px;
      width: 20px;
      top: 20px;
      border-bottom-right-radius: 10px;
      border-top-right-radius: 10px;
      box-shadow: rgba(0, 0, 0, 0.18) -20px 20px 80px;
    }
    .frame-tertiary-wrapper {
      background: #fff;
      /* border: 1px solid #ccc;
      border-left: none; */
      position: absolute;
      left: 250px;
      height: 320px;
      width: 20px;
      top: 40px;
      border-bottom-right-radius: 10px;
      border-top-right-radius: 10px;
      box-shadow: rgba(0, 0, 0, 0.18) -20px 20px 80px;
    }

    iframe {
      border-radius: 15px !important;
    }
  }
}
</style>
